/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { translateValue$Json } from '../fn/translation/translate-value-json';
import { TranslateValue$Json$Params } from '../fn/translation/translate-value-json';
import { translateValue$Plain } from '../fn/translation/translate-value-plain';
import { TranslateValue$Plain$Params } from '../fn/translation/translate-value-plain';

@Injectable({ providedIn: 'root' })
export class TranslationService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `translateValue()` */
  static readonly TranslateValuePath = '/translate';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `translateValue$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  translateValue$Plain$Response(params?: TranslateValue$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = translateValue$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `translateValue$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  translateValue$Plain(params?: TranslateValue$Plain$Params, context?: HttpContext): Observable<string> {
    const resp = this.translateValue$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `translateValue$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  translateValue$Json$Response(params?: TranslateValue$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<string>> {
    const obs = translateValue$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `translateValue$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  translateValue$Json(params?: TranslateValue$Json$Params, context?: HttpContext): Observable<string> {
    const resp = this.translateValue$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<string>): string => r.body)
    );
  }

}
